import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43bea9f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"normal"} }, "¿Eres el mítico Narsil?", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"normal"} }, " ¿Se permiten emparejamientos de la misma comunidad de juego? ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"normal"} }, " ¿Prevalece luz vs oscuridad? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"normal"} }, " Los jugadores son impares. ¿Cómo quieres gestionarlo? ", -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "emparejamientos-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"white-space":"normal"} }, "Emparejamientos:", -1))
const _hoisted_9 = { style: {"white-space":"normal"} }

import {
  Emparejamiento,
  GenerarRonda,
  JugadorParaEmparejamiento,
} from "@/interfaces/Live";
import {
  InscripcionTorneoCreadoMasDTO,
  TorneoGestionInfoMasDTO,
} from "@/interfaces/Torneo";
import { generarRonda } from "@/services/PartidaTorneoService";
import { ref, watch, onMounted, computed } from "vue";
import { getInfoTorneoCreadoMasAsync } from "@/services/TorneosService";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalParametrosPrimeraRondaMas',
  props: {
    isVisible: { type: Boolean },
    torneo: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newValue) => {
    internalIsVisible.value = newValue;
  }
);

const mismaComunidadCheck = ref<boolean>(false);
const mismaComunidadCheckString = ref<string>("SI");
const isTorneoNarsil = ref<string>("NO");
const goodVsEvilCheck = ref<boolean>(false);
const goodVsEvilCheckString = ref<string>("SI");
const retosCheck = ref<boolean>(false);
const esEloCheck = ref<boolean>(false);
const opcionImpares = ref<string | null>(null);
const isImpares = ref<boolean>(false);
const numeroRonda = ref<number>(1);

const inscripciones = ref<InscripcionTorneoCreadoMasDTO[]>();
const jugadoresNick = ref<JugadorParaEmparejamiento[]>();
const jugador1 = ref<JugadorParaEmparejamiento>();
const jugador2 = ref<JugadorParaEmparejamiento>();

const rondas = ref<number[]>();
const isGenerating = ref<boolean>(false);
const torneoSelected = ref<TorneoGestionInfoMasDTO>();

const errorRonda = ref<string | null>(null);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const emparejamientos = ref<
  { jugador1: JugadorParaEmparejamiento; jugador2: JugadorParaEmparejamiento }[]
>([]);
const isAddEmparejamientoEnabled = computed(() => {
  return jugador1.value && jugador2.value && jugador1.value !== jugador2.value;
});

watch(numeroRonda, (newValue) => {
  if (newValue) {
    errorRonda.value = null;
  }
});

onMounted(async () => {
  try {
    if (!props.torneo?.torneo.idTorneo) {
      console.error("El idTorneo no está definido");
      return;
    }
    // Obtener información del torneo creado
    const responseTorneo = await getInfoTorneoCreadoMasAsync(
      props.torneo?.torneo.idTorneo
    );
    torneoSelected.value = responseTorneo.data;

    // Si hay inscripciones, procesar jugadores
    if (torneoSelected.value?.inscripciones) {
      inscripciones.value = torneoSelected.value.inscripciones;
      isImpares.value = inscripciones.value?.length % 2 !== 0;

      // Usamos `for...of` para manejar promesas de manera secuencial o `map` con `Promise.all`
      jugadoresNick.value = torneoSelected.value?.inscripciones.map(
        (element) => ({
          idUsuario: element.idUsuario,
          nick: element.nick,
        })
      );
    }

    // Procesar rondas si existe el número de partidas
    if (torneoSelected.value?.torneo?.numeroPartidas) {
      const totalRondas = torneoSelected.value.torneo.numeroPartidas;
      rondas.value = Array.from({ length: totalRondas }, (_, i) => i + 1);
    }
  } catch (error) {
    console.error("Error al obtener la información del torneo:", error);
  }
});

const addEmparejamiento = () => {
  //Validaciones

  if (!jugador1.value || !jugador2.value) {
    alert("No puedes dejar a los jugadores en blanco");
    return;
  }

  if (jugador1.value.idUsuario === jugador2.value.idUsuario) {
    alert("No puedes emparejar al mismo jugador.");
    return;
  }

  const isJugador1InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador1.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador1.value!.idUsuario
  );
  const isJugador2InEmparejamientos: boolean = emparejamientos.value.some(
    (emparejamiento) =>
      emparejamiento.jugador1.idUsuario === jugador2.value!.idUsuario ||
      emparejamiento.jugador2.idUsuario === jugador2.value!.idUsuario
  );

  if (isJugador1InEmparejamientos || isJugador2InEmparejamientos) {
    alert("Uno o ambos jugadores ya están emparejados.");
    return;
  }

  const emparejamientoTerminado: Emparejamiento = {
    jugador1: jugador1.value,
    jugador2: jugador2.value,
  };
  emparejamientos.value.push(emparejamientoTerminado);

  jugador1.value = undefined;
  jugador2.value = undefined;
};

const removeEmparejamiento = (index: number) => {
  emparejamientos.value.splice(index, 1);
};

const confirmarConfiguracion = async () => {
  if (!numeroRonda.value) {
    errorRonda.value = "El número de ronda es obligatorio.";
    return;
  }
  if (!props.torneo?.torneo.idTorneo) {
    console.error("El idTorneo no está definido");
    return;
  }

  errorRonda.value = null;
  if (mismaComunidadCheckString.value === "SI")
    mismaComunidadCheck.value = true;
  else mismaComunidadCheck.value = false;

  if (goodVsEvilCheckString.value === "SI") goodVsEvilCheck.value = true;
  else goodVsEvilCheck.value = false;

  let isNarsil = false;
  if (isTorneoNarsil.value === "SI") isNarsil = true;

  const configuracion: GenerarRonda = {
    mismaComunidadCheck: mismaComunidadCheck.value,
    luzVsOscCheck: goodVsEvilCheck.value,
    retosCheck: retosCheck.value,
    emparejamientos: emparejamientos.value,
    esEloCheck: esEloCheck.value,
    opcionImpares: opcionImpares.value,
    idTorneo: props.torneo?.torneo.idTorneo,
    idRonda: numeroRonda.value,
    isTorneoNarsil: isNarsil,
  };

  try {
    isGenerating.value = true;

    await generarRonda(configuracion);
    showSuccessModal.value = true;
  } catch (error) {
    showErrorModal.value = true;
    console.error(error);
  } finally {
    isGenerating.value = false;
  }

  emit("confirm", configuracion);
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { style: {"white-space":"normal"} }, {
              default: _withCtx(() => [
                _createTextVNode(" Configurar Ronda ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: isTorneoNarsil.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isTorneoNarsil).value = $event)),
                      class: "text-wrap"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_1
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "Sí",
                          value: "SI"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "No",
                          value: "NO"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (isTorneoNarsil.value === 'NO')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_v_radio_group, {
                            modelValue: mismaComunidadCheckString.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mismaComunidadCheckString).value = $event)),
                            class: "text-wrap"
                          }, {
                            label: _withCtx(() => [
                              _hoisted_3
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Sí",
                                value: "SI"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "No",
                                value: "NO"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_radio_group, {
                            modelValue: goodVsEvilCheckString.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((goodVsEvilCheckString).value = $event)),
                            class: "text-wrap"
                          }, {
                            label: _withCtx(() => [
                              _hoisted_4
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Sí",
                                value: "SI"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "No",
                                value: "NO"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (isImpares.value)
                      ? (_openBlock(), _createBlock(_component_v_radio_group, {
                          key: 1,
                          modelValue: opcionImpares.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((opcionImpares).value = $event)),
                          class: "text-wrap"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_5
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Hacer un bye",
                              value: "bye"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_checkbox, {
                      modelValue: retosCheck.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((retosCheck).value = $event)),
                      label: "¿Tenemos algún reto para esta ronda?",
                      class: "text-wrap",
                      style: {"white-space":"normal"}
                    }, null, 8, ["modelValue"]),
                    (retosCheck.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador1.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((jugador1).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 1",
                            class: "mb-2"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_combobox, {
                            modelValue: jugador2.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((jugador2).value = $event)),
                            items: jugadoresNick.value,
                            "item-title": "nick",
                            "item-value": "idUsuario",
                            label: "Jugador 2",
                            class: "mb-2"
                          }, null, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_btn, {
                            disabled: !isAddEmparejamientoEnabled.value,
                            variant: "tonal",
                            color: "blue",
                            onClick: addEmparejamiento,
                            block: "",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Agregar Emparejamiento ")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_divider, { class: "my-3" }),
                    (emparejamientos.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _hoisted_8,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emparejamientos.value, (emparejamiento, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "emparejamiento-item d-flex align-center justify-space-between my-2"
                            }, [
                              _createElementVNode("span", _hoisted_9, " Mesa " + _toDisplayString(index + 1) + ": " + _toDisplayString(emparejamiento.jugador1.nick) + " vs " + _toDisplayString(emparejamiento.jugador2.nick), 1),
                              _createVNode(_component_v_btn, {
                                class: "remove-btn",
                                onClick: ($event: any) => (removeEmparejamiento(index)),
                                icon: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-delete")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "auto",
                      class: "mb-2 mb-sm-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: isGenerating.value,
                          onClick: confirmarConfiguracion,
                          color: "primary",
                          variant: "tonal",
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Generar ronda ")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: closeModal,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cancelar ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card d-flex justify-center pa-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Ronda generada correctamente.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido generarla ronda. Inténtalo de nuevo y si el error persiste, contacta con el administrador.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})